(function () {
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  function openCart() {
    // Monster Cart (and the theme drawer) open when the cart icon is clicked.
    document.dispatchEvent(new CustomEvent('bloom:cart-updated'));
    var icon = document.getElementById('cart-icon-bubble') || document.querySelector('a[href="/cart"]');
    if (icon) icon.click();
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
      return r.json();
    });
  }

  function shipLine(el, cartCents, extraCents) {
    if (!el) return;
    var goal = parseInt(el.getAttribute('data-goal'), 10) || 10000;
    var total = cartCents + (extraCents || 0);
    var left = goal - total;
    var text = el.querySelector('[data-ship-text]');
    var bar = el.querySelector('[data-ship-bar]');
    if (text) text.textContent = left > 0
      ? "You're " + money(left) + ' away from free US shipping.'
      : "You've unlocked free US shipping!";
    if (bar) bar.style.width = Math.min(100, Math.round((total / goal) * 100)) + '%';
  }

  function init(root) {
    var mode = root.getAttribute('data-mode');
    var ship = root.querySelector('[data-ship]');
    var cartCents = 0;
    var refresh = function () { return getCart().then(function (c) { cartCents = c.total_price; update(); }).catch(function () {}); };

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-variant]'));
    var countEl = root.querySelector('[data-count]');
    var totalEl = root.querySelector('[data-total]');
    var addAll = root.querySelector('[data-add-all]');

    function picked() {
      return cards.map(function (c) {
        return { id: +c.getAttribute('data-variant'), qty: +(c.getAttribute('data-qty') || 0), price: +c.getAttribute('data-price') };
      }).filter(function (p) { return p.qty > 0; });
    }

    function update() {
      var sel = picked();
      var n = sel.reduce(function (a, p) { return a + p.qty; }, 0);
      var cents = sel.reduce(function (a, p) { return a + p.qty * p.price; }, 0);
      if (countEl) countEl.textContent = n === 1 ? '1 towel' : n + ' towels';
      if (totalEl) totalEl.textContent = money(cents);
      if (addAll) addAll.disabled = n === 0;
      var bar = root.querySelector('.bloom-stack__bar'); if (bar) bar.classList.toggle('is-active', n > 0);
      shipLine(ship, cartCents, cents);
    }

    cards.forEach(function (card) {
      var out = card.querySelector('output');
      card.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b.hasAttribute('data-plus') || b.hasAttribute('data-minus')) {
          var q = +(card.getAttribute('data-qty') || 0) + (b.hasAttribute('data-plus') ? 1 : -1);
          q = Math.max(0, Math.min(99, q));
          card.setAttribute('data-qty', q);
          if (out) out.textContent = q;
          card.classList.toggle('bloom-stack__card--picked', q > 0);
          update();
        }
        if (b.hasAttribute('data-add-one')) {
          var label = b.textContent;
          b.disabled = true; b.textContent = 'Adding…';
          addItems([{ id: +card.getAttribute('data-variant'), quantity: 1 }]).then(function () {
            b.textContent = 'Added ✓ Add another'; b.classList.add('bloom-stack__btn--added'); b.disabled = false;
            refresh(); openCart();
          }).catch(function (err) { b.textContent = label; b.disabled = false; alertLine(root, err.message); });
        }
      });
    });

    if (addAll) addAll.addEventListener('click', function () {
      var sel = picked();
      if (!sel.length) return;
      var label = addAll.textContent;
      addAll.disabled = true; addAll.textContent = 'Adding…';
      addItems(sel.map(function (p) { return { id: p.id, quantity: p.qty }; })).then(function () {
        cards.forEach(function (c) { c.setAttribute('data-qty', 0); var o = c.querySelector('output'); if (o) o.textContent = 0; c.classList.remove('bloom-stack__card--picked'); });
        addAll.textContent = label;
        refresh(); openCart();
      }).catch(function (err) { addAll.textContent = label; addAll.disabled = false; alertLine(root, err.message); });
    });

    document.addEventListener('bloom:cart-updated', function () { setTimeout(refresh, 800); });
    refresh();
  }

  function alertLine(root, msg) {
    var el = root.querySelector('[data-error]');
    if (el) { el.textContent = msg; el.hidden = false; setTimeout(function () { el.hidden = true; }, 6000); }
  }

  function place(root) {
    // On product pages, move the row up to sit right under the main product section.
    if (root.getAttribute('data-place') !== 'after-product') return;
    var main = document.querySelector('main') || document;
    var form = main.querySelector('form[action*="/cart/add"]');
    var sec = form && (form.closest('.shopify-section') || form.closest('section'));
    if (sec && sec.parentNode && !sec.contains(root)) sec.parentNode.insertBefore(root, sec.nextSibling);
  }

  function boot() { document.querySelectorAll('.bloom-stack[data-mode]').forEach(function (r) { if (!r.__bs) { r.__bs = 1; place(r); init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
